// extracted by mini-css-extract-plugin
module.exports = {"tagList":"TagList_tagList__JTLTt","tagGroup":"TagList_tagGroup__LDPVL"};